module.exports = __webpack_public_path__ + "img/facebook.af3f73fe.svg";